export default __webpack_public_path__ + "static/media/filter-icon.8a5a50e1.svg";